export default {
  name: 'review',
  title: 'Product Review',
  type: 'document',
  fields: [
    {
      name: 'productSlug',
      title: 'Product Slug',
      type: 'string',
      description: 'The slug of the product this review is for',
      validation: Rule => Rule.required()
    },
    {
      name: 'name',
      title: 'Reviewer Name',
      type: 'string',
      validation: Rule => Rule.required()
    },
    {
      name: 'email',
      title: 'Email',
      type: 'string',
      hidden: true
    },
    {
      name: 'rating',
      title: 'Rating',
      type: 'number',
      validation: Rule => Rule.required().min(1).max(5),
      options: {
        list: [1, 2, 3, 4, 5]
      }
    },
    {
      name: 'text',
      title: 'Review Text',
      type: 'text',
      validation: Rule => Rule.required()
    },
    {
      name: 'source',
      title: 'Source',
      type: 'string',
      initialValue: 'Website',
      options: {
        list: ['Website', 'Facebook', 'Verified Purchase', 'Email', 'Other']
      }
    },
    {
      name: 'reply',
      title: 'Reply from Isaías',
      type: 'text'
    },
    {
      name: 'status',
      title: 'Status',
      type: 'string',
      initialValue: 'pending',
      options: {
        list: [
          { title: 'Pending Review', value: 'pending' },
          { title: 'Approved', value: 'approved' },
          { title: 'Rejected', value: 'rejected' }
        ]
      }
    },
    {
      name: 'reviewDate',
      title: 'Review Date',
      type: 'datetime',
      initialValue: () => new Date().toISOString()
    }
  ],
  preview: {
    select: {
      title: 'name',
      subtitle: 'productSlug',
      rating: 'rating',
      status: 'status'
    },
    prepare(selection) {
      var stars = '★'.repeat(selection.rating || 0);
      return {
        title: selection.title + ' - ' + stars,
        subtitle: selection.productSlug + ' (' + (selection.status || 'pending') + ')'
      };
    }
  },
  orderings: [
    {
      title: 'Review Date, New',
      name: 'reviewDateDesc',
      by: [{ field: 'reviewDate', direction: 'desc' }]
    },
    {
      title: 'Status',
      name: 'statusAsc',
      by: [{ field: 'status', direction: 'asc' }]
    }
  ]
};
